import { arrowProgrammeImg } from '@/components/Card/Programme';
import { CustomImage } from '@/components/CustomImage';
import { ProgrammePage } from '@edwin-group/cj-graphql';
import { memo } from 'react';

export const ProgrammeHero = memo(({ page }: { page: ProgrammePage }) => {
  const imageSrc = page?.cover.url;

  return (
    <div>
      <div className="relative">
        <div className="h-full max-h-[477px] w-full max-w-[849px] overflow-hidden rounded-2xl">
          <CustomImage
            src={imageSrc}
            alt={page?.cover.alternativeText || page?.title || 'Programme cover'}
            className="!h-full !max-h-[477px] !w-full !max-w-[849px] object-cover"
          />
        </div>
        <img
          src={arrowProgrammeImg}
          alt="arrow content type"
          className="-bottom-5.5 absolute right-10 -translate-y-1/2"
        />
      </div>
      <h2 className="mt-sh-60 !font-cadiz text-sh-28-32 font-bold">{page?.title}</h2>
      <p className="mt-2.5 text-sh-sm">{page?.description}</p>
    </div>
  );
});

ProgrammeHero.displayName = 'ProgrammeHero';
